import { render } from "./MessageModal.vue?vue&type=template&id=a7268c60&scoped=true&ts=true"
import script from "./MessageModal.vue?vue&type=script&lang=ts"
export * from "./MessageModal.vue?vue&type=script&lang=ts"

import "./MessageModal.vue?vue&type=style&index=0&id=a7268c60&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7268c60"]])

export default __exports__